<template>
  <TooltipProvider>
    <TooltipRoot :disabled="disabled">
      <TooltipTrigger as-child>
        <slot name="trigger"></slot>
      </TooltipTrigger>

      <TooltipPortal :to="portalRootElementSelector">
        <TooltipContent
          class="data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade text-basics-primary select-none rounded-[4px] bg-brand-bg-main px-[15px] py-[10px] text-base leading-none shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity]"
          :class="{ hidden: disabled, '!p-0': noPadding }"
          :style="{ 'z-index': 9999999999 }"
          :side-offset="5"
          :side="side"
        >
          <slot></slot>
          <TooltipArrow class="fill-brand-bg-main" :width="8" />
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>

<script setup lang="ts">
import { portalRootElementSelector } from "@/constants/ui";
import {
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from "reka-ui";

defineProps<{
  disabled?: boolean;
  side?: "top" | "right" | "bottom" | "left";
  noPadding?: boolean;
}>();
</script>
